import type { Partner } from '../types/content'

export const partnerBenefits = [
  'Social media platform exposure',
  'Live-stream broadcast visibility',
  'Motorsport photography and editorial coverage',
  'Trackside exposure with an engaged audience',
  'Car displays for openings, expos and community events',
  'Custom videos featuring your team and brand',
  'Driver and race-car appearances at your business',
]

export const supportOptions = [
  'Travel and accommodation',
  'Fuel and transport to the track',
  'Tyres and parts',
  'Safety equipment',
  'Nomination fees',
]

export const partners: Partner[] = [
  {name: "Stationery Direct", url:"https://stationery-direct.com.au/", logo: "StationeryDirect Logo.png"},
  {name: "Jess Jones Realestate", url:"https://jessjonesrealestate.com.au/", logo: "Jess_Jones_Realestate_Logo.png"},
  {name: "New Light Media", url:"https://newlightmedia.com.au", logo: "NLM_Logo_Light.png"},
  {name: "Xfactor Plumbing", url:"https://xfactorplumbing.com.au/", logo: "Xfactor_Plumbing_Logo.png"},
  {name: "Toowoomba Steering & Suspension", url:"https://www.toowoombasteeringandsuspension.com.au/", logo: "TSS_LOGO.png"},
  {name: "S&S Genrich Painting", url:"https://www.facebook.com/p/S-S-Genrich-Pty-Ltd-100068168043397/", logo: "S&S_Genrich_Painting_Logo.png"},
  {name: "MFI Industries", url:"", logo: "MFI_New_logo.png"},
  // Add sponsor logo files to public/assets/partners and enter them here.
]
